var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, persistent: "", "max-width": "820px" },
      on: { "click:outside": _vm.closeModal },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("v-icon", { attrs: { color: "primary" } }, [
                _vm._v("mdi-store"),
              ]),
              _c("span", { staticClass: "pl-2" }, [
                _vm._v(_vm._s(_vm.storeParty.store_name)),
              ]),
              _vm.stores.length
                ? _c("span", { staticClass: "pl-2 text-body-2 grey--text" }, [
                    _vm._v(
                      "(" +
                        _vm._s(_vm.stores.length) +
                        " " +
                        _vm._s(_vm.stores.length === 1 ? "store" : "stores") +
                        ")"
                    ),
                  ])
                : _vm._e(),
              _c("v-spacer"),
              _vm.customerPortalBase && _vm.canManageStoreGroups
                ? _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { text: "", small: "", color: "primary" },
                      on: { click: _vm.openInCustomerUi },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-launch"),
                      ]),
                      _vm._v("Manage in Customer UI "),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.closeModal } },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.sortedStores,
              height: 250,
              "items-per-page": -1,
              dense: "",
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function ({ item }) {
                  return [
                    _c(
                      "tr",
                      {
                        style: _vm.isPrimary(item) ? _vm.primaryRowStyle : null,
                      },
                      [
                        _c(
                          "td",
                          { staticClass: "noWrap" },
                          [
                            _vm._v(" " + _vm._s(item.store_name) + " "),
                            _vm.isPrimary(item)
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      "x-small": "",
                                      color: "primary",
                                      label: "",
                                    },
                                  },
                                  [_vm._v("Primary")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "text-center" },
                          [
                            _vm.isPricePro(item)
                              ? _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      "x-small": "",
                                      color: "save",
                                      "text-color": "white",
                                      label: "",
                                    },
                                  },
                                  [_vm._v("Price Pro")]
                                )
                              : _c("span", { staticClass: "grey--text" }, [
                                  _vm._v("—"),
                                ]),
                          ],
                          1
                        ),
                        _c("td", { staticClass: "noWrap" }, [
                          _vm._v(_vm._s(_vm.formatDateDisplay(item.start_dt))),
                        ]),
                        _c("td", { staticClass: "noWrap" }, [
                          _vm._v(_vm._s(_vm.formatDateDisplay(item.end_dt))),
                        ]),
                        _c("td", { staticClass: "noWrap" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatDateTimestampDisplay(item.created_on)
                            )
                          ),
                        ]),
                        _vm.canViewStoreId
                          ? _c(
                              "td",
                              { staticClass: "text-center" },
                              [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.copyStoreId(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        color:
                                                          _vm.copiedId ===
                                                          _vm.storeId(item)
                                                            ? "save"
                                                            : "primary",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.copiedId ===
                                                              _vm.storeId(item)
                                                              ? "mdi-check"
                                                              : "mdi-content-copy"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.copiedId === _vm.storeId(item)
                                            ? "Copied!"
                                            : "Copy store ID"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("label", { staticClass: "font-weight-light mx-4 note-label" }, [
            _vm._v(
              'Note: The primary store of a store group is determined by the store\'s relationship type to the TPR Store Group. The store with the active "Focal Store" relationship is the primary store.'
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }